import React, { useState } from 'react';

/**
 * Renders the Sapience logo from /logo.png (place the file in frontend/public/).
 * If the image is missing it falls back to the original "T" mark so the UI
 * never breaks.
 */
export default function Logo({ className = '', fallbackClassName = '', alt = 'Sapience' }) {
  const [failed, setFailed] = useState(false);
  if (failed) return <div className={fallbackClassName}>T</div>;
  return (
    <img
      src="/logo.png"
      alt={alt}
      className={className}
      onError={() => setFailed(true)}
    />
  );
}
